/**
 * PRICE cell helpers. Validation allows a PRICE of 0, so 0 is always a real
 * mark here: only an absent/empty or non-finite value counts as "no price".
 */

/** A finite price, or null for an absent, empty or non-numeric value. */
export const toFinitePrice = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'string' && value.trim() === '') return null;
  const n = typeof value === 'number' ? value : parseFloat(String(value).replace(/,/g, ''));
  return Number.isFinite(n) ? n : null;
};

/** A price with 4 decimals (0 renders `0.0000`); '' when there is no price. */
export const formatPrice4 = (value) => {
  const n = toFinitePrice(value);
  return n === null ? '' : n.toFixed(4);
};

/**
 * AG Grid valueParser for PRICE. Clearing the cell yields null; a finite
 * number (0 included) is kept; anything else is rejected and the previous
 * value is returned, so a bad paste never stores NaN or blanks a saved mark.
 */
export const parsePriceCellValue = (newValue, oldValue) => {
  if (newValue === null || newValue === undefined) return null;
  if (typeof newValue === 'string' && newValue.trim() === '') return null;
  const n = toFinitePrice(newValue);
  if (n !== null) return n;
  return oldValue === undefined ? null : oldValue;
};
